import { Redirect } from 'wouter';
import { environment } from '@shared/config';
import { getUserRoles, hasAuthToken } from '@infra/auth';
import { appendLocaleParam } from '@infra/i18n';
import { rememberReturnPath } from '@modules/shell';

type RequireAuthWouterProps = {
  roles?: string[];
  children: React.ReactNode;
};

export const RequireAuthWouter = ({ roles = [], children }: RequireAuthWouterProps) => {
  const authenticated = hasAuthToken();

  if (!authenticated) {
    if (environment.loginUrl) {
      // Lets login return the visitor to the page they asked for.
      rememberReturnPath(`${window.location.pathname}${window.location.search}`);
      window.location.replace(appendLocaleParam(environment.loginUrl));
      return null;
    }
    return <Redirect href="/" />;
  }

  if (roles.length) {
    const userRoles = getUserRoles();
    const missingRole = roles
      .map((role) => role.toLowerCase())
      .find((role) => !userRoles.includes(role));

    if (missingRole) {
      return <Redirect href="/" />;
    }
  }

  return <>{children}</>;
};
